import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
	en: {
		translation: {
			"GameName": "Minesweeper Pro",
			"Beginner": "Beginner",
			"Intermediate": "Intermediate",
			"Expert": "Expert",
			"TimeIsUpMessage": "Time is up",
			"Notification": "Notification",
			"FullScreenAdInfo": "Advertising will start in"
		}
	},
	ru: {
		translation: {
			"GameName": "Сапер Профи",
			"Beginner": "Новичок",
			"Intermediate": "Любитель",
			"Expert": "Профессионал",
			"TimeIsUpMessage": "Время вышло",
			"Notification": "Оповещение",
			"FullScreenAdInfo": "Реклама начнется через"
		}
	},
	tr: {
		translation: {
			"GameName": "Mayın Tarlası Pro",
			"Beginner": "Başlangıç",
			"Intermediate": "Orta Seviye",
			"Expert": "Profesyonel",
			"TimeIsUpMessage": "Süre doldu",
			"Notification": "Tebligat",
			"FullScreenAdInfo": "Reklamlar başlayacak"
		}
	}
};

i18n
	.use(LanguageDetector)
	.use(initReactI18next) // passes i18n down to react-i18next
	.init({
		resources,
		fallbackLng: 'en',
		debug: false,
		interpolation: {
			escapeValue: false // react already safes from xss
		}
	}).then();

export default i18n;